<template>
  <v-card>
    <v-card-title>
      {{$t('Page.EditForm.header')}}
    </v-card-title>
    <v-card-text>
      <v-text-field 
        v-model="name" 
        :label="$t('Page.EditForm.title')"
        required
        outlined
      ></v-text-field>
      <v-select 
        v-model="selectedModel"
        :items="availableModels" 
        item-text="name"
        :label="$t('Page.EditForm.models')" 
        :hint="$t('Page.EditForm.modelsHint')" 
        persistent-hint
        return-object
        outlined
      ></v-select>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="confirm" :disabled="!name">{{$t('Global.Action.confirm')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'PageEditForm',
  props: {
    models: { type: Array, required: false, default: () => [] }
  },
  data: () => ({
    selectedModel: null,
    name: ''
  }),
  computed: {
    availableModels () {
      return [
        {
          name: this.$t('Page.EditForm.modelEmpty'),
          layout: []
        },
        ...this.models
      ]
    }
  },
  methods: {
    init () {
      this.name = ''
      this.selectedModel = this.availableModels[0]
    },
    async confirm () {
      this.$emit('submit', {
        name: this.name, 
        layout: this.selectedModel.layout
      })
      this.init()
    }
  },
  created () {
    this.init()
  }
}
</script>